module.exports = __webpack_public_path__ + "static/img/banner.e66434d5.jpg";